<div class="file-upload">
  <div class="file-upload-disabled-overlay" *ngIf="disabled"></div>
  <div
    class="file-upload-wrapper"
    [ngClass]="{ 'center-align': centerField }"
    (drop)="onFileDropped($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (click)="fileInput.click()"
  >
    <div *ngIf="files.length > 0; else uploadPrompt">
      <div style="position: absolute; top: 0px; right: 0px">
        <p-button variant="text" (click)="clearFiles($event)">
          <i class="fas fa-times"></i>
        </p-button>
      </div>
      <div class="file-upload-details" *ngFor="let file of files">

        <p style="margin: 0px; font-family: Montserrat, sans-serif">
          {{ file.name }}
        </p>
      </div>
    </div>
    <ng-template #uploadPrompt>
      <div class="file-upload-prompt">
        <div class="ddinfo-container">
          <i class="fas fa-cloud-upload-alt" style="font-size: 5rem; color: #2ea3f2; width: 86px"></i>

          <div class="ddinfo">Drag & Drop File</div>
          <div class="ddinfo">

            or <span class="ddinfo--underline">Browse</span>
          </div>
        </div>
      </div>
    </ng-template>
    <input
      type="file"
      (change)="onFileSelected($event)"
      [attr.accept]="acceptedFileTypes"
      [multiple]="allowMultiple"
      hidden
      #fileInput
    />
  </div>
</div>
